export const FETCH_USER_INFO_STARTED = 'FETCH/USER/INFO/STARTED';
export const FETCH_USER_INFO_SUCCESS = 'FETCH/USER/INFO/SUCCESS';
export const FETCH_USER_INFO_FAILURE = 'FETCH/USER/INFO/FAILURE';
export const REALTIME_UPDATE         = 'REALTIME/UPDATE';
